export default __webpack_public_path__ + "static/media/job-board-bg-top.9b645065.png";